export const USERS_FETCH = 'USERS/FETCH';
export const USERS_FETCH_SUCCESS = 'USERS/FETCH_SUCCESS';
export const USERS_FETCH_FAILURE = 'USERS/FETCH_FAILURE';
export const USERS_DELETE_USER = 'USERS/DELETE_USER';
export const USERS_DELETE_USER_SUCCESS = 'USERS/DELETE_USER_SUCCESS';
export const USERS_DELETE_USER_FAILURE = 'USERS/DELETE_USER_FAILURE';
export const USERS_TOGGLE_ACTIVE_USER = 'USERS_TOGGLE_ACTIVE_USER';
export const USERS_TOGGLE_ACTIVE_USER_SUCCESS =
  'USERS_TOGGLE_ACTIVE_USER_SUCCESS';
export const USERS_TOGGLE_ACTIVE_USER_FAILURE =
  'USERS_TOGGLE_ACTIVE_USER_FAILURE';
export const USER_CREATE_EMPTY_USER = 'USER/CREATE_EMPTY_USER';
export const USER_SAVE = 'USER/SAVE';
export const USER_SAVE_SUCCESS = 'USER/SAVE_SUCCESS';
export const USER_SAVE_FAILURE = 'USER/SAVE_FAILURE';
export const USER_EDIT = 'USER/EDIT';
export const USER_FETCH = 'USER/FETCH';
export const USER_FETCH_SUCCESS = 'USER/FETCH_SUCCESS';
export const USER_FETCH_FAILURE = 'USER/FETCH_FAILURE';
export const USER_ADD_IMAGE = 'USER/ADD_IMAGE';

const initialState = {
  list: [],
  current: {},
};

export const fetchUsers = () => ({
  type: USERS_FETCH,
});

export const deleteUser = id => ({
  type: USERS_DELETE_USER,
  payload: { id },
});

export const toggleUserActive = user => ({
  type: USERS_TOGGLE_ACTIVE_USER,
  payload: { user },
});

export const createEmptyUser = () => ({
  type: USER_CREATE_EMPTY_USER,
  payload: {},
});

export const editUser = user => ({
  type: USER_EDIT,
  payload: user,
});

export const saveUser = user => ({
  type: USER_SAVE,
  payload: { user },
});

export const fetchUser = id => ({
  type: USER_FETCH,
  payload: { id },
});

export const addUserImage = data => ({
  type: USER_ADD_IMAGE,
  payload: { data },
});

export const usersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case USERS_FETCH_SUCCESS: {
      return {
        list: [...payload],
      };
    }
    case USERS_FETCH_FAILURE: {
      console.error(USERS_FETCH_FAILURE);
      return state;
    }
    case USERS_DELETE_USER_SUCCESS: {
      return {
        ...state,
        list: state.list.filter(user => user.id !== payload.id),
      };
    }
    case USERS_DELETE_USER_FAILURE: {
      console.error(USERS_DELETE_USER_FAILURE);
      return state;
    }
    case USERS_TOGGLE_ACTIVE_USER_SUCCESS: {
      const index = state.list.findIndex(user => user.id === payload.id);

      return {
        ...state,
        list: [
          ...state.list.slice(0, index),
          payload,
          ...state.list.slice(index + 1),
        ],
      };
    }
    case USER_SAVE_SUCCESS: {
      return { ...state, current: { payload } };
    }
    case USER_SAVE_FAILURE: {
      console.error(USER_SAVE_FAILURE);
      return state;
    }
    case USER_CREATE_EMPTY_USER: {
      return {
        ...state,
        current: {
          fullName: '',
          email: '',
          company: '',
          password: '',
          confirmPassword: '',
          isActive: false,
          isAdmin: false,
          avatarUrl: '',
        },
      };
    }
    case USER_EDIT: {
      return { ...state, current: payload };
    }
    case USER_ADD_IMAGE: {
      return {
        ...state,
        current: { ...state.current, avatarUrl: payload.data.url },
      };
    }
    case USER_FETCH_SUCCESS: {
      return { ...state, current: { ...payload } };
    }
    case USER_FETCH_FAILURE: {
      console.error(USER_FETCH_FAILURE);
      return state;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/users.reducer.js